import CookieHandler from './cookie_handler';

export default () => ({
  login: payload => {
    CookieHandler().setToken(payload);
  }
});
